import { createAsyncThunk } from '@reduxjs/toolkit';
import { LoginVariables } from '@/shared/api';
import { gatewayApi } from '@/shared/api/gateway-api';

export const login = createAsyncThunk(
  'auth/signInUser',
  async ({ username, password }: LoginVariables, { dispatch }) => {
    const { result } = await dispatch(
      gatewayApi.endpoints.login.initiate({ username, password })
    ).unwrap();

    return result;
  }
);

export const logout = createAsyncThunk(
  'auth/logOutUser',
  async (_, { dispatch }) => {
    dispatch(gatewayApi.endpoints.logout.initiate()).unwrap();
  }
);
